import { forwardRef } from "react";
import TextareaAutosize from "react-textarea-autosize";
import ClickIcon from "../../../components/essentials/icon-buttons/click-icon/ClickIcon";
import "./AcedTextBox.scss";

export interface TextBoxProps {
  text: string;
  setText: (value: string) => void;
  onSend: () => void;
  placeholder?: string;
  maxRows?: number;
  mode: "dark" | "light";
}

const AcedTextBox = forwardRef<HTMLTextAreaElement, TextBoxProps>(
  ({ text, setText, onSend, placeholder, maxRows, mode }, ref) => {
    const colors = {
      dark: "white",
      light: "black",
    };

    return (
      <div className={`aced-text-box aced-text-box-${mode}`}>
        <TextareaAutosize
          ref={ref}
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxRows={maxRows ?? 3}
          placeholder={placeholder}
          style={{ color: colors[mode] }}
        />
        <ClickIcon icon="send" color={colors[mode]} onClick={onSend} />
      </div>
    );
  }
);

export default AcedTextBox;
